import { put, call, takeLatest, delay } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';

function* timelineListGet(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('page', payload.page);
    let lsObj = JSON.parse(localStorage.getItem('TimelineCondition'));
    if (lsObj.footprintFilter) {
      params.append('footprintFilter', lsObj.footprintFilter);
    }
    return axios.post(config.apiUri + "member/timelineListApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield delay(100);
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "TIMELINE_LIST_SET",
        payload: {
          list: res.data.list,
          page: action.payload.page,
          isList: res.data.isList,
          isListNext: res.data.isListNext,
          datetime: (new Date()),
        },
      });
    }
  }

  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }

  yield put(loadingSet(false));
}


function* timelineFootprintListGet(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('date', payload.date);
    params.append('page', payload.page);
    let lsObj = JSON.parse(localStorage.getItem('TimelineCondition'));
    if (lsObj.footprintFilter) {
      params.append('footprintFilter', lsObj.footprintFilter);
    }
    return axios.post(config.apiUri + "member/timelineFootprintPartnerListApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {
    if (res.data.bool) {
      yield put({
        type: "TIMELINE_FOOTPRINT_LIST_SET",
        payload: {
          date: action.payload.date,
          list: res.data.list,
          page: action.payload.page,
          isListNext: res.data.isListNext,
          datetime: (new Date()),
        },
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

const saga = [
  takeLatest('TIMELINE_LIST_GET', timelineListGet),
  takeLatest('TIMELINE_FOOTPRINT_LIST_GET', timelineFootprintListGet),
];

export default saga;
